import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillsAndPaymentsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 13.506,
			height: 13.506,
			x: 2.247,
			y: 2.247,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			rx: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M15.753 5.999H2.247m8.065 2.588a.037.037 0 1 0 0 .074.037.037 0 0 0 0-.074m-2.626 2.251a.036.036 0 0 0-.036.037.037.037 0 1 0 .036-.037m-2.626 0a.036.036 0 0 0-.037.038q.002.024.023.034a.037.037 0 1 0 .013-.07m2.627 2.25a.036.036 0 0 0-.036.037.037.037 0 1 0 .036-.037m-2.626 0a.036.036 0 0 0-.037.037.037.037 0 1 0 .036-.037m7.879-4.502a.036.036 0 0 0-.036.037.037.037 0 0 0 .063.026.037.037 0 0 0-.027-.063"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M10.313 8.588a.037.037 0 1 0 0 .074.037.037 0 0 0 0-.074m-.001 2.25a.037.037 0 1 0 0 .074.037.037 0 0 0 0-.074m2.626.002a.036.036 0 0 0-.036.036.037.037 0 0 0 .063.026.037.037 0 0 0-.027-.063"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M10.313 10.84a.037.037 0 1 0 0 .073.037.037 0 0 0 0-.073"
		})
	]
});
export default SvgBillsAndPaymentsinline;
